import React, { useContext, useState } from "react";
import { registerUser } from '../../api/api';
import { useNavigate } from "react-router-dom";
import "./SignUpPage.css";
import { AppContext } from "../../appContext";

export const SignUpPage = () => {
    const {translate} = useContext(AppContext);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleSignUp = async ()=>{
        try {
            await registerUser(email, password);
            navigate('/dashboard');
        } catch (error) {
            alert(error.message);
        }
    }

    
    const loginWithGoogle = () => {

    }

    const clickSignIn= () => {
        navigate('/login');
    }


    return (
        <div className="signUpPage">
            <div className="signUpPage_background">
            
            </div>
            <div className="signUpPage_wrapper">
                <div className="signUpPage_header">
                    <div className="signUpPage_logo">{translate('login_Appname')}</div>
                    <div className="button signUpPage_signUp" onClick={clickSignIn}>{translate('signup_login')}</div>
                </div>
                <div className="signUpPage_main">
                    <div className="signUpPopup">
                        <div className="signUpPopup_title">
                            {translate('signup_title')}
                        </div>
                        <div className="signUpPopup_form">
                            <div className="signUpPopup_input">
                                <div className="signUpPopup_input_label">
                                    {translate('signup_name')}
                                </div>
                                <input type="text" className="signUpPopup_input_field" />
                            </div>
                            <div className="signUpPopup_input">
                                <div className="signUpPopup_input_label">
                                    {translate('signup_email')}
                                </div>
                                <input type="email" className="signUpPopup_input_field" value={email} onChange={e=>setEmail(e.target.value)} />
                            </div>
                            <div className="signUpPopup_input">
                                <div className="signUpPopup_input_label">
                                    {translate('signup_password')}
                                </div>
                                <input type="password" className="signUpPopup_input_field" value={password} onChange={e=>setPassword(e.target.value)} />
                            </div>
                            <div className="signUpPopup_input">
                                <div className="signUpPopup_input_label">
                                    {translate('signup_repeat_password')}
                                </div>
                                <input type="password" className="signUpPopup_input_field" />
                            </div>
                            <div className="signUpPopup_remember">
                                <div className="button signUpPopup_check">
                                    <div className="signUpPopup_check_box">
                                    
                                    </div>
                                    <div className="signUpPopup_check_label">
                                        {translate('signup_remember_me')}
                                    </div>
                                </div>
                            </div>
                            <div className="button saveButton signUpPopup_submit" onClick={handleSignUp}>
                                {translate('signup_proceed')}
                            </div>
                        </div>
                        <div className="signUpPopup_otherAuth">
                            <div className="signUpPopup_otherAuth_or">
                                {translate('signup_or')}
                            </div>
                            <div className="button signUpPopup_otherAuth_google">
                                <div className="signUpPopup_otherAuth_google_ico">

                                </div>
                                <div className="signUpPopup_otherAuth_google_text">
                                    {translate('signup_google')}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="signUpPage_footer">
                    <div className="signUpPage_footer_text">
                        © 2021. - 2025 {translate('login_AllRightsText')}
                    </div>
                </div>
            </div>
        </div>
    )
}